import {useContext} from 'react';
import HardwareCatalogContext from "../Context/HardwareCatalogContext";

// ==============================|| HARDWARE CATALOG HOOKS ||============================== //

const useHardwareCatalog = () => {
    const context = useContext(HardwareCatalogContext);

    if (!context)
        throw new Error('context must be use inside provider');

    return context;
};

export default useHardwareCatalog;
